export default __webpack_public_path__ + "static/media/message.8e435be1.png";